/**
 * Do not edit directly
 * Generated on 2026-04-17T09:37:10.875Z
 */

export const tokens = {
  "breakpoint": {
    "5xs": "320px",
    "4xs": "360px",
    "3xs": "375px",
    "2xs": "512px",
    "xs": "768px",
    "sm": "864px",
    "md": "1024px",
    "lg": "1280px",
    "xl": "1440px",
    "2xl": "1680px",
    "3xl": "1920px"
  },
  "code": {
    "light": {
      "comment": "#5e636aff",
      "keyword": "#3f7824ff",
      "keywordLiteral": "#3f7824ff",
      "operator": "#3f7824ff",
      "label": "#d43300ff",
      "predicateFunction": "#0a6190ff",
      "function": "#0a6190ff",
      "procedure": "#0a6190ff",
      "stringLiteral": "#986400ff",
      "numberLiteral": "#754ec8ff",
      "booleanLiteral": "#754ec8ff",
      "paramValue": "#754ec8ff",
      "property": "#730e00ff"
    },
    "dark": {
      "comment": "#959aa1ff",
      "keyword": "#ffc450ff",
      "keywordLiteral": "#ffc450ff",
      "operator": "#ffc450ff",
      "label": "#f96746ff",
      "predicateFunction": "#8fe3e8ff",
      "function": "#8fe3e8ff",
      "procedure": "#8fe3e8ff",
      "stringLiteral": "#90cb62ff",
      "numberLiteral": "#ccb4ffff",
      "booleanLiteral": "#ccb4ffff",
      "paramValue": "#ccb4ffff",
      "property": "#ffaa97ff"
    }
  },
  "content": {
    "extraLight": {
      "maxWidth": "768px"
    },
    "light": {
      "maxWidth": "1024px"
    },
    "heavy": {
      "maxWidth": "1680px"
    },
    "max": {
      "maxWidth": "1920px"
    }
  },
  "categorical": {
    "1": "#55bdc5ff",
    "2": "#4d49cbff",
    "3": "#dc8b39ff",
    "4": "#c9458dff",
    "5": "#8e8cf3ff",
    "6": "#78de7cff",
    "7": "#3f80e3ff",
    "8": "#673fabff",
    "9": "#dbbf40ff",
    "10": "#bf732dff",
    "11": "#478a6eff",
    "12": "#ade86bff"
  },
  "graph": {
    "1": "#ffdf81ff",
    "2": "#c990c0ff",
    "3": "#f79767ff",
    "4": "#56c7e4ff",
    "5": "#f16767ff",
    "6": "#d8c7aeff",
    "7": "#8dcc93ff",
    "8": "#ecb4c9ff",
    "9": "#4d8ddaff",
    "10": "#ffc354ff",
    "11": "#da7294ff",
    "12": "#579380ff"
  },
  "motion": {
    "duration": {
      "quick": "100ms",
      "slow": "250ms"
    },
    "easing": {
      "standard": "cubic-bezier(0.42, 0, 0.58, 1)"
    },
    "transition": {
      "quick": "100ms cubic-bezier(0.42, 0, 0.58, 1) 0ms",
      "slow": "250ms cubic-bezier(0.42, 0, 0.58, 1) 0ms",
      "delayed": "100ms cubic-bezier(0.42, 0, 0.58, 1) 100ms"
    }
  },
  "palette": {
    "baltic": {
      "10": "#e7fafbff",
      "15": "#c3f8fbff",
      "20": "#8fe3e8ff",
      "25": "#5cc3c9ff",
      "30": "#5db3bfff",
      "35": "#51a6b1ff",
      "40": "#4c99a4ff",
      "45": "#30839dff",
      "50": "#0a6190ff",
      "55": "#02507bff",
      "60": "#014063ff",
      "65": "#262f31ff",
      "70": "#081e2bff",
      "75": "#041823ff",
      "80": "#01121cff"
    },
    "hibiscus": {
      "10": "#ffe9e7ff",
      "15": "#ffd7d2ff",
      "20": "#ffaa97ff",
      "25": "#ff8e6aff",
      "30": "#f96746ff",
      "35": "#e84e2cff",
      "40": "#d43300ff",
      "45": "#bb2d00ff",
      "50": "#961200ff",
      "55": "#730e00ff",
      "60": "#432520ff",
      "65": "#4e0900ff",
      "70": "#3f0800ff",
      "75": "#360700ff",
      "80": "#280500ff"
    },
    "forest": {
      "10": "#e7fcd7ff",
      "15": "#bcf194ff",
      "20": "#90cb62ff",
      "25": "#80bb53ff",
      "30": "#6fa646ff",
      "35": "#5b992bff",
      "40": "#4d8622ff",
      "45": "#3f7824ff",
      "50": "#296127ff",
      "55": "#145439ff",
      "60": "#0c4d31ff",
      "65": "#0a4324ff",
      "70": "#262d24ff",
      "75": "#052618ff",
      "80": "#021d11ff"
    },
    "lemon": {
      "10": "#fffad1ff",
      "15": "#fff8bdff",
      "20": "#fff178ff",
      "25": "#ffe500ff",
      "30": "#ffd600ff",
      "35": "#f4c318ff",
      "40": "#d7aa0aff",
      "45": "#b48409ff",
      "50": "#996e00ff",
      "55": "#765500ff",
      "60": "#614600ff",
      "65": "#4d3700ff",
      "70": "#312e1aff",
      "75": "#2e2100ff",
      "80": "#251b00ff"
    },
    "lavender": {
      "10": "#f7f3ffff",
      "15": "#e9deffff",
      "20": "#ccb4ffff",
      "25": "#b38effff",
      "30": "#a07becff",
      "35": "#8c68d9ff",
      "40": "#754ec8ff",
      "45": "#5a34aaff",
      "50": "#4b2894ff",
      "55": "#3b1982ff",
      "60": "#2c2a34ff",
      "65": "#220954ff",
      "70": "#170146ff",
      "75": "#0e002dff",
      "80": "#09001cff"
    },
    "marigold": {
      "10": "#fff0d2ff",
      "15": "#ffde9dff",
      "20": "#ffcf72ff",
      "25": "#ffc450ff",
      "30": "#ffb422ff",
      "35": "#ffa901ff",
      "40": "#ec9c00ff",
      "45": "#da9105ff",
      "50": "#ba7a00ff",
      "55": "#986400ff",
      "60": "#795000ff",
      "65": "#624100ff",
      "70": "#543800ff",
      "75": "#422c00ff",
      "80": "#251900ff"
    },
    "earth": {
      "10": "#fff7f0ff",
      "15": "#fdeddaff",
      "20": "#ffe1c5ff",
      "25": "#f8d1aeff",
      "30": "#ecbf96ff",
      "35": "#e0ae7fff",
      "40": "#d19660ff",
      "45": "#af7c4dff",
      "50": "#8d5d31ff",
      "55": "#763f18ff",
      "60": "#66310bff",
      "65": "#5b2b09ff",
      "70": "#481f01ff",
      "75": "#361700ff",
      "80": "#220e00ff"
    },
    "neutral": {
      "10": "#ffffffff",
      "15": "#f5f6f6ff",
      "20": "#e2e3e5ff",
      "25": "#cfd1d4ff",
      "30": "#bbbec3ff",
      "35": "#a8acb2ff",
      "40": "#959aa1ff",
      "45": "#818790ff",
      "50": "#6f757eff",
      "55": "#5e636aff",
      "60": "#4d5157ff",
      "65": "#3c3f44ff",
      "70": "#212325ff",
      "75": "#1a1b1dff",
      "80": "#09090aff"
    },
    "beige": {
      "10": "#fffcf4ff",
      "20": "#fff7e3ff",
      "30": "#f2ead4ff",
      "40": "#c1b9a0ff",
      "50": "#999384ff",
      "60": "#666050ff",
      "70": "#3f3824ff"
    },
    "highlights": {
      "yellow": "#faff00ff",
      "periwinkle": "#6a82ffff"
    }
  },
  "borderRadius": {
    "none": "0px",
    "sm": "4px",
    "md": "6px",
    "lg": "8px",
    "xl": "12px",
    "2xl": "16px",
    "3xl": "24px",
    "full": "9999px"
  },
  "space": {
    "2": "2px",
    "4": "4px",
    "6": "6px",
    "8": "8px",
    "12": "12px",
    "16": "16px",
    "20": "20px",
    "24": "24px",
    "32": "32px",
    "48": "48px",
    "64": "64px"
  },
  "theme": {
    "dark": {
      "boxShadow": {
        "raised": "0px 1px 2px 0px rgb(from #09090aff r g b / 0.50)",
        "overlay": "0px 8px 20px 0px rgb(from #09090aff r g b / 0.50)"
      },
      "color": {
        "neutral": {
          "text": {
            "weakest": "#818790ff",
            "weaker": "#a8acb2ff",
            "weak": "#cfd1d4ff",
            "default": "#f5f6f6ff",
            "inverse": "#1a1b1dff"
          },
          "icon": "#cfd1d4ff",
          "bg": {
            "weak": "#212325ff",
            "default": "#1a1b1dff",
            "strong": "#3c3f44ff",
            "stronger": "#6f757eff",
            "strongest": "#f5f6f6ff",
            "status": "#a8acb2ff",
            "on-bg-weak": "#81879014"
          },
          "border": {
            "weak": "#3c3f44ff",
            "strong": "#5e636aff",
            "strongest": "#bbbec3ff"
          },
          "hover": "#959aa11a",
          "pressed": "#959aa133"
        },
        "primary": {
          "text": "#8fe3e8ff",
          "icon": "#8fe3e8ff",
          "bg": {
            "weak": "#262f31ff",
            "strong": "#8fe3e8ff",
            "status": "#5db3bfff",
            "selected": "#262f31ff"
          },
          "border": {
            "strong": "#8fe3e8ff",
            "weak": "#02507bff"
          },
          "focus": "#5db3bfff",
          "hover": {
            "weak": "#8fe3e814",
            "strong": "#5db3bfff"
          },
          "pressed": {
            "weak": "#8fe3e81f",
            "strong": "#4c99a4ff"
          }
        },
        "danger": {
          "text": "#ffaa97ff",
          "icon": "#ffaa97ff",
          "bg": {
            "strong": "#ffaa97ff",
            "weak": "#432520ff",
            "status": "#f96746ff"
          },
          "border": {
            "strong": "#ffaa97ff",
            "weak": "#730e00ff"
          },
          "hover": {
            "weak": "#ffaa9714",
            "strong": "#f96746ff"
          },
          "pressed": {
            "weak": "#ffaa971f"
          },
          "strong": "#e84e2cff"
        },
        "warning": {
          "text": "#ffd600ff",
          "icon": "#ffd600ff",
          "bg": {
            "strong": "#ffd600ff",
            "weak": "#312e1aff",
            "status": "#d7aa0aff"
          },
          "border": {
            "strong": "#ffd600ff",
            "weak": "#765500ff"
          }
        },
        "success": {
          "text": "#90cb62ff",
          "icon": "#90cb62ff",
          "bg": {
            "strong": "#90cb62ff",
            "weak": "#262d24ff",
            "status": "#6fa646ff"
          },
          "border": {
            "strong": "#90cb62ff",
            "weak": "#296127ff"
          }
        },
        "discovery": {
          "text": "#ccb4ffff",
          "icon": "#ccb4ffff",
          "bg": {
            "strong": "#ccb4ffff",
            "weak": "#2c2a34ff",
            "status": "#a07becff"
          },
          "border": {
            "strong": "#ccb4ffff",
            "weak": "#4b2894ff"
          }
        }
      }
    },
    "light": {
      "boxShadow": {
        "raised": "0px 1px 2px 0px rgb(from #1a1b1dff r g b / 0.18)",
        "overlay": "0px 4px 8px 0px rgb(from #1a1b1dff r g b / 0.12)"
      },
      "color": {
        "neutral": {
          "text": {
            "weakest": "#a8acb2ff",
            "weaker": "#5e636aff",
            "weak": "#4d5157ff",
            "default": "#1a1b1dff",
            "inverse": "#ffffffff"
          },
          "icon": "#4d5157ff",
          "bg": {
            "weak": "#ffffffff",
            "default": "#f5f6f6ff",
            "on-bg-weak": "#f5f6f6ff",
            "strong": "#e2e3e5ff",
            "stronger": "#a8acb2ff",
            "strongest": "#3c3f44ff",
            "status": "#a8acb2ff"
          },
          "border": {
            "weak": "#e2e3e5ff",
            "strong": "#bbbec3ff",
            "strongest": "#6f757eff"
          },
          "hover": "#6f757e1a",
          "pressed": "#6f757e33"
        },
        "primary": {
          "text": "#0a6190ff",
          "icon": "#0a6190ff",
          "bg": {
            "weak": "#e7fafbff",
            "strong": "#0a6190ff",
            "status": "#4c99a4ff",
            "selected": "#e7fafbff"
          },
          "border": {
            "strong": "#0a6190ff",
            "weak": "#8fe3e8ff"
          },
          "focus": "#30839dff",
          "hover": {
            "weak": "#30839d1a",
            "strong": "#02507bff"
          },
          "pressed": {
            "weak": "#30839d1f",
            "strong": "#014063ff"
          }
        },
        "danger": {
          "text": "#bb2d00ff",
          "icon": "#bb2d00ff",
          "bg": {
            "strong": "#bb2d00ff",
            "weak": "#ffe9e7ff",
            "status": "#e84e2cff"
          },
          "border": {
            "strong": "#bb2d00ff",
            "weak": "#ffaa97ff"
          },
          "hover": {
            "weak": "#d4330014",
            "strong": "#961200ff"
          },
          "pressed": {
            "weak": "#d433001f",
            "strong": "#730e00ff"
          }
        },
        "warning": {
          "text": "#765500ff",
          "icon": "#765500ff",
          "bg": {
            "strong": "#765500ff",
            "weak": "#fffad1ff",
            "status": "#d7aa0aff"
          },
          "border": {
            "strong": "#996e00ff",
            "weak": "#ffd600ff"
          }
        },
        "success": {
          "text": "#3f7824ff",
          "icon": "#3f7824ff",
          "bg": {
            "strong": "#3f7824ff",
            "weak": "#e7fcd7ff",
            "status": "#5b992bff"
          },
          "border": {
            "strong": "#3f7824ff",
            "weak": "#90cb62ff"
          }
        },
        "discovery": {
          "text": "#5a34aaff",
          "icon": "#5a34aaff",
          "bg": {
            "strong": "#5a34aaff",
            "weak": "#e9deffff",
            "status": "#754ec8ff"
          },
          "border": {
            "strong": "#5a34aaff",
            "weak": "#b38effff"
          }
        }
      }
    }
  },
  "weight": {
    "bold": 700,
    "semibold": 600,
    "normal": 400,
    "medium": 500,
    "light": 300
  },
  "typography": {
    "code": {
      "fontFamily": "Fira Code",
      "fontSize": "0.875rem",
      "fontWeight": 400,
      "letterSpacing": "0rem",
      "lineHeight": 1.4286
    },
    "display": {
      "fontFamily": "Syne Neo",
      "fontSize": "2.5rem",
      "fontWeight": 500,
      "letterSpacing": "0rem",
      "lineHeight": 1.2
    },
    "title-1": {
      "fontFamily": "Public Sans",
      "fontSize": "1.875rem",
      "fontWeight": 700,
      "letterSpacing": "0.016rem",
      "lineHeight": 1.3333
    },
    "title-2": {
      "fontFamily": "Public Sans",
      "fontSize": "1.5rem",
      "fontWeight": 700,
      "letterSpacing": "0.016rem",
      "lineHeight": 1.3333
    },
    "title-3": {
      "fontFamily": "Public Sans",
      "fontSize": "1.25rem",
      "fontWeight": 700,
      "letterSpacing": "0.016rem",
      "lineHeight": 1.4
    },
    "title-4": {
      "fontFamily": "Public Sans",
      "fontSize": "1rem",
      "fontWeight": 700,
      "letterSpacing": "0.016rem",
      "lineHeight": 1.5
    },
    "subheading-large": {
      "fontFamily": "Public Sans",
      "fontSize": "1.25rem",
      "fontWeight": 600,
      "letterSpacing": "0.016rem",
      "lineHeight": 1.4
    },
    "subheading-medium": {
      "fontFamily": "Public Sans",
      "fontSize": "1rem",
      "fontWeight": 600,
      "letterSpacing": "0.016rem",
      "lineHeight": 1.5
    },
    "subheading-small": {
      "fontFamily": "Public Sans",
      "fontSize": "0.875rem",
      "fontWeight": 600,
      "letterSpacing": "0rem",
      "lineHeight": 1.4286
    },
    "body-large": {
      "fontFamily": "Public Sans",
      "fontSize": "1rem",
      "fontWeight": 400,
      "letterSpacing": "0rem",
      "lineHeight": 1.5
    },
    "body-medium": {
      "fontFamily": "Public Sans",
      "fontSize": "0.875rem",
      "fontWeight": 400,
      "letterSpacing": "0rem",
      "lineHeight": 1.4286
    },
    "body-small": {
      "fontFamily": "Public Sans",
      "fontSize": "0.75rem",
      "fontWeight": 400,
      "letterSpacing": "0rem",
      "lineHeight": 1.6667
    },
    "label": {
      "fontFamily": "Public Sans",
      "fontSize": "0.875rem",
      "fontWeight": 700,
      "letterSpacing": "0rem",
      "lineHeight": 1.4286
    }
  },
  "zIndex": {
    "deep": -999999,
    "base": 0,
    "overlay": 10,
    "banner": 20,
    "blanket": 30,
    "popover": 40,
    "tooltip": 50,
    "modal": 60
  }
};
export default tokens;